import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { PortsideStripe, PortsideMark } from "@/components/Brand";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    handled.current = true;

    const run = async () => {
      const hash = window.location.hash || "";
      const m = hash.match(/session_id=([^&]+)/);
      const sid = m ? decodeURIComponent(m[1]) : null;
      if (!sid) {
        navigate("/login");
        return;
      }
      try {
        const r = await api.post("/auth/session", { session_id: sid });
        setUser(r.data);
        // clear hash
        window.history.replaceState({}, document.title, window.location.pathname);
        // Land on Inspection Gate In if approved (primary daily workflow), otherwise /pending will pick them up
        const dest = r.data?.status === "approved" ? "/inspection/entry" : "/pending";
        navigate(dest, { replace: true, state: { user: r.data } });
      } catch (e) {
        console.error("session exchange failed", e);
        navigate("/login?error=session_failed", { replace: true });
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#f8fafc]">
      <PortsideStripe />
      <div className="grid place-items-center h-[80vh]">
        <div className="flex flex-col items-center gap-4">
          <PortsideMark />
          <div className="w-10 h-10 rounded-full border-4 border-slate-200 border-t-[#ff5b2c] animate-spin" />
          <div className="overline">Signing you in</div>
        </div>
      </div>
    </div>
  );
}
